module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert text-center"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('autoInscription.shareTheLink')))]), _c('br'), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('input', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.autoInscriptionLink),
      expression: "autoInscriptionLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "text-center form-control",
    staticStyle: {
      "color": "#007700"
    },
    attrs: {
      "id": "autoLink",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.autoInscriptionLink
    }
  }), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.autoInscriptionLink),
      expression: "autoInscriptionLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('qrcode', {
    attrs: {
      "value": _vm.autoInscriptionLink,
      "options": {
        width: 200
      }
    }
  })], 1), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('br'), _c('br'), _c('h5', [_vm._v(_vm._s(_vm.$t('autoInscription.shareDirect')))]), _c('social-sharing', {
    attrs: {
      "url": _vm.autoInscriptionLink,
      "title": "Deviens membre de " + this.groop.name + " sur GroopUs.com !",
      "description": "",
      "hashtags": "groopus.com,simple,efficace"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "btn-group text-center"
          }, [_c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via email",
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-envelope"
          }), _vm._v(" Email")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via SMS",
              "network": "sms"
            }
          }, [_c('i', {
            staticClass: "fa fa-commenting-o"
          }), _vm._v(" SMS")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via facebook",
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          }), _vm._v(" Facebook")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via Telegram",
              "network": "telegram"
            }
          }, [_c('i', {
            staticClass: "fa fa-telegram"
          }), _vm._v(" Telegram")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via Whatsapp",
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp"
          }), _vm._v(" Whatsapp")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via LinkedIn",
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-linkedin"
          }), _vm._v(" LinkedIn")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via Reddit",
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit"
          }), _vm._v(" Reddit")]), _c('network', {
            staticClass: "btn btn-default",
            staticStyle: {
              "float": "initial",
              "margin-bottom": "10px"
            },
            attrs: {
              "title": "Via Skype",
              "network": "skype"
            }
          }, [_c('i', {
            staticClass: "fa fa-skype"
          }), _vm._v(" Skype")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]), _c('br'), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("autoInscription.linkToShare.shareIt"))), _c('a', {
    attrs: {
      "href": _vm.autoInscriptionLink,
      "target": "_blank"
    }
  }, [_vm._v("  " + _vm._s(_vm.$t("autoInscription.linkToShare.testIt"))), _c('i', {
    staticClass: "fa fa-external-link"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e14eaa2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupManagement/AutoInscription.vue
// module id = 997
// module chunks = 1 4